export default {
  path: '/printing_surface_sizes',
  name: 'printing_surface_sizes',
  component: () => import('../components/printingsurfacesize/Layout'),
  redirect: { name: 'PrintingSurfaceSizeList' },
  meta: {
    breadcrumb: 'profile.printingsurface.sizes',
  },
  children: [
    {
      name: 'PrintingSurfaceSizeList',
      path: '',
      component: () => import('../views/printingsurfacesize/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'PrintingSurfaceSizeCreate',
      path: 'new',
      component: () => import('../views/printingsurfacesize/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'PrintingSurfaceSizeUpdate',
      path: ':id/edit',
      component: () => import('../views/printingsurfacesize/Update'),
      meta: {
        breadcrumb: 'profile.printingsurface.size',
      },
    },
    {
      name: 'PrintingSurfaceSizeShow',
      path: ':id',
      component: () => import('../views/printingsurfacesize/Show'),
      meta: {
        breadcrumb: 'profile.printingsurface.size',
      },
    }
  ]
};
